"use client";

/**
 * SummerBackground
 *
 * Background decorations for Summer theme.
 * Part of the decoration system - controlled via NEXT_PUBLIC_ACTIVE_DECORATIONS.
 *
 * Fixed-position corner decorations pinned to the bottom-left and bottom-right edges.
 */
export function SummerBackground() {
  return (
    <div aria-hidden="true" className="pointer-events-none select-none">
      {/* Bottom Left */}
      <img
        src="/images/decorations/summer/summer-left.webp"
        alt=""
        width={227}
        height={508}
        loading="lazy"
        decoding="async"
        className="fixed bottom-0 left-0 hidden xl:block z-0"
      />

      {/* Bottom Right */}
      <img
        src="/images/decorations/summer/summer-right.webp"
        alt=""
        width={237}
        height={510}
        loading="lazy"
        decoding="async"
        className="fixed bottom-0 right-0 hidden xl:block z-0"
      />
    </div>
  );
}
